<template>
  <VDropdown
    v-if="(isLoggedIn && onlyLogin) || !onlyLogin"
    ref="paramsPopper"
    placement="top-end"
    popper-class="v-popper__popperq popover popover__Menu"
    @apply-show="focusInputFirstEl"
  >
    <button
      id="label-settings"
      v-tooltip.bottom="$t('generic.settings')"
      class="border-gray-100 border-r flex items-center my-5 pr-4 relative"
      :class="{ 'border-none': onlyLogin }"
    >
      <loading
        v-model:active="loading"
        :is-full-page="false"
        :height="34"
      />
      <div
        v-if="isLoggedIn"
        class="flex items-center"
      >
        <Avatar
          :fullname="userInfo.username"
          :size="34"
          class="mr-2"
          :image="avatar"
        />
        <span class="navinfos__username">{{ userInfo.username }}</span>
      </div>
      <IconWrap
        v-if="!isLoggedIn && !loading && !onlyLogin"
        class="ml-4"
        label="settings"
      >
        <IconSettings />
      </IconWrap>
    </button>
    <template
      #popper
      class="text-gray-400"
    >
      <div class="version">
        {{ $t("general.version") }}
      </div>
      <ul>
        <li class="popover__Menu--item">
          <form class="flex items-center">
            <label
              for="langDashboard"
              class="capitalize font-semibold"
            >{{ $t("layout.navigation.language", 1) }}</label>
            <MenuLang
              ref="menuLang"
              name="langDashboard"
              class="ml-2"
            />
          </form>
        </li>
        <li
          v-if="isLoggedIn"
          class="popover__Menu--item"
        >
          <a
            class="--no-style"
            :href="accountLink"
            target="_blank"
            rel="noopener noreferrer"
          >{{ $t("layout.account.account") }}</a>
        </li>
        <li
          v-if="isLoggedIn"
          class="popover__Menu--item"
        >
          <button @click="logout">
            {{ $t("layout.account.disconnect") }}
          </button>
        </li>
        <hr class="border-gray-100 my-2">
        <!--
        Whats'new + Credits page
        <li class="popover__Menu--item">
          <router-link class="--no-style" v-tooltip="'Work In Progress'" to="#">{{ $t("pages.updates.meta.title") }}</router-link>
        </li>
        <li class="popover__Menu--item">
          <router-link class="--no-style" v-tooltip="'Work In Progress'" to="#">{{ $t("pages.credits.meta.title") }}</router-link>
        </li>
        -->
        <li class="popover__Menu--item">
          <router-link
            class="--no-style"
            :to="{ name: 'TechnicalProcess'}"
          >
            {{ $t("pages.home.technicalProcess") }}
          </router-link>
        </li>
        <li class="popover__Menu--item">
          <router-link
            class="--no-style"
            :to="{ name: 'Press'}"
          >
            {{ $t("pages.press.title") }}
          </router-link>
        </li>
        <li class="popover__Menu--item">
          <router-link
            class="--no-style"
            :to="{ name: 'Contact' }"
          >
            {{ $t("pages.contact.meta.title") }}
          </router-link>
        </li>
      </ul>
      <NavSocialLinks class="pt-4 px-5" />
    </template>
  </VDropdown>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import Avatar from 'vue-avatar-component';
import IconSettings from '@/assets/images/icons/Settings';
import IconWrap from '@/assets/images/icons';
import NavSocialLinks from '@/components/common/NavSocialLinks';


export default {
  name: 'UserNavAccountSettings',

  components: {
    Avatar,
    NavSocialLinks,
    IconWrap,
    IconSettings
  },

  props: {
    onlyLogin: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      loading: undefined
    };
  },

  computed: {
    ...mapState('user', ['userInfo', 'avatar']),
    ...mapGetters('user', ['isLoggedIn']),
    accountLink() {
      return `${process.env.VUE_APP_SMAPSHOT_BACKOFFICE_URL}`;
    }
  },

  methods: {
    logout() {
      this.$store.dispatch('user/logout');
      this.$refs.paramsPopper.hide();
    },

    focusInputFirstEl() {
      this.$forceNextTick(() => {
        this.$refs.menuLang.$el.querySelector('select').focus();
      });
    }
  }
};
</script>

<style lang="postcss">
.navinfos__username{
  text-overflow: ellipsis;
  max-width:15ch;
  white-space: nowrap;
  overflow: hidden;
}
.version {
  font-size: 9px;
  position: absolute;
  text-align: right;
  bottom: -16px;
  right: 4px;
}
</style>
